import { icon_arrow_right } from '@gn-audio/icons';

import { mapSharedPropertiesToFields } from '../../../getters';
import { SitecoreFieldTypes } from '../../../types';
import { Button } from '../../Button/Button';
import { JabraFocusItem } from '../../JabraFocus';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { ScopedStyle } from '../../ScopedStyle/ScopedStyle';
import { CampaignCard } from '../MegaMenuTypes';
import { getBgBasedColor, getRandomBGColor } from '../MegaMenuUtils';
import { BackgroundImage } from './BackgroundImage';

import styles from './Cards.module.css';

interface CampaignsProps {
  items: {
    id: string;
    fields: SitecoreFieldTypes;
  }[];
}

export const Campaigns = ({ items }: CampaignsProps): JSX.Element => {
  const bgColors = items.map((item) => getRandomBGColor(item.id));
  return (
    <div>
      {items.map((card, index) => {
        const cardSettings = mapSharedPropertiesToFields<CampaignCard>(card.fields);
        const bgColor = cardSettings.BackgroundImage?.value?.src ? 'big-photo' : bgColors[index];
        const bgBasedColor = getBgBasedColor(bgColor);

        return cardSettings.Link ? (
          <ScopedStyle
            id={card.id}
            css={cardSettings.Style?.value}
            renderItem={(styleLinkingProp) => (
              <JabraFocusItem key={card.id} asChild>
                <a
                  href={cardSettings.Link?.value?.href}
                  className={`group relative hover:no-underline ${styles.card} ${bgColor} ${bgBasedColor.text}`}
                  {...styleLinkingProp}
                >
                  {cardSettings.BackgroundImage?.value?.src ? (
                    <BackgroundImage
                      field={cardSettings.BackgroundImage}
                      externalField={{
                        altText: cardSettings.Header?.value || 'Campaign Image',
                      }}
                      cardType="big"
                    />
                  ) : null}
                  <div className="z-10 flex-col">
                    <p className={styles.header}>{cardSettings.Header?.value}</p>
                    <p className={styles.description}>{cardSettings.Description?.value}</p>
                    <p className={styles.footer}>{cardSettings.Footer?.value}</p>
                  </div>
                  <Button
                    variant="primary"
                    size="m"
                    icon={<JabraIcon className="size-5" Icon={icon_arrow_right} />}
                    noKeyboard
                  />
                </a>
              </JabraFocusItem>
            )}
          />
        ) : null;
      })}
    </div>
  );
};
